import { Box, TextField, Typography } from "@mui/material";
import CustomDatePicker from "../../datePicker/customDatePicker.component";
import { TextFieldStyles } from "../../../styles/commonStyles";
import { isCurrentCulture } from "../../muiTabs/utils";

const CultureInfo = ({
  initialData,
  register,
  memoizedCrops,
  startDate,
  handleStartDateSelect,
  errors,
  fieldCulture,
  endDate,
  handleEndDateSelect,
  today,
}) => {
  const lastCulture = initialData?.field_colture
    ? initialData?.field_colture[initialData.field_colture.length - 1]
    : null;
  const currentCulture = isCurrentCulture(lastCulture) ? lastCulture : null;

  return (
    <>
      <Typography fontSize="14px" fontWeight="bold">
        Coltura attuale
      </Typography>
      <TextField
        variant="filled"
        select
        defaultValue={currentCulture?.colture?.id || ""}
        sx={TextFieldStyles}
        label="Coltura attuale"
        InputLabelProps={{
          shrink: Boolean(fieldCulture) || undefined,
        }}
        {...register("field_colture")}
      >
        {memoizedCrops}
      </TextField>
      <Box display="flex" gap={2} width="100%">
        <CustomDatePicker
          label="Data di inizio"
          id="start_date"
          selectedDate={startDate}
          handleDateSelect={handleStartDateSelect}
          error={errors?.start_date?.message}
          disabled={!fieldCulture}
        />
        <CustomDatePicker
          label="Data di fine"
          id="end_date"
          selectedDate={endDate}
          handleDateSelect={handleEndDateSelect}
          error={errors?.end_date?.message}
          disabledDays={{ before: startDate && today }}
          disabled={!fieldCulture}
        />
      </Box>
    </>
  );
};

export default CultureInfo;
